function clamp(n) {
  return Math.max(0, Math.min(255, Math.round(n)));
}

export function normalizeHex(hex, fallback = '#004852') {
  if (!hex || typeof hex !== 'string') return fallback;
  let h = hex.trim();
  if (!h.startsWith('#')) h = `#${h}`;
  if (/^#[0-9a-fA-F]{3}$/.test(h)) {
    h = `#${h[1]}${h[1]}${h[2]}${h[2]}${h[3]}${h[3]}`;
  }
  if (!/^#[0-9a-fA-F]{6}$/.test(h)) return fallback;
  return h.toLowerCase();
}

function hexToRgb(hex) {
  const h = normalizeHex(hex).slice(1);
  const n = parseInt(h, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

function rgbToHex({ r, g, b }) {
  return `#${[r, g, b].map((x) => clamp(x).toString(16).padStart(2, '0')).join('')}`;
}

function mix(a, b, t) {
  return {
    r: a.r + (b.r - a.r) * t,
    g: a.g + (b.g - a.g) * t,
    b: a.b + (b.b - a.b) * t,
  };
}

export function buildPrimaryPalette(primaryHex) {
  const base = hexToRgb(primaryHex);
  const white = { r: 255, g: 255, b: 255 };
  const black = { r: 0, g: 0, b: 0 };
  return {
    50: rgbToHex(mix(white, base, 0.08)),
    100: rgbToHex(mix(white, base, 0.18)),
    200: rgbToHex(mix(white, base, 0.35)),
    300: rgbToHex(mix(white, base, 0.55)),
    400: rgbToHex(mix(white, base, 0.75)),
    500: normalizeHex(primaryHex),
    600: rgbToHex(mix(base, black, 0.18)),
    700: rgbToHex(mix(base, black, 0.32)),
    800: rgbToHex(mix(base, black, 0.48)),
    900: rgbToHex(mix(base, black, 0.64)),
  };
}

export function applyThemeToDocument(primaryHex) {
  const primary = normalizeHex(primaryHex);
  const palette = buildPrimaryPalette(primary);
  const root = document.documentElement;
  const rgb = hexToRgb(primary);

  root.style.setProperty('--primary-color', primary);
  root.style.setProperty('--color-primary', primary);
  root.style.setProperty('--primary-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`);

  Object.entries(palette).forEach(([shade, value]) => {
    root.style.setProperty(`--primary-${shade}`, value);
  });

  return palette;
}
